import { render } from "./PublicParent.vue?vue&type=template&id=9d6c3e3a&scoped=true&ts=true"
import script from "./PublicParent.vue?vue&type=script&lang=ts"
export * from "./PublicParent.vue?vue&type=script&lang=ts"

import "./PublicParent.vue?vue&type=style&index=0&id=9d6c3e3a&lang=scss&scoped=true"
import "./PublicParent.vue?vue&type=style&index=1&id=9d6c3e3a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d6c3e3a"]])

export default __exports__